
// phapay 
export const END_IMAGE =  "https://lailaopayment-bucket.s3.ap-southeast-1.amazonaws.com/images/"

// local
// export const END_POINT_SEVER = "http://localhost:7000";

// productin 
export const END_POINT_SEVER = "https://z62s92dujl.execute-api.ap-southeast-1.amazonaws.com";











// payment api
// export const PAYMENT_SECRET_KEY = "$2a$10$GQZDKLX86Gb7ZQX/XV5HROoZng4T9ecl7bZcjEub/BoG.2FtCLhMW"
// export  const PAYMENT_GATEWAY_URL = "https://payment-gateway.lailaolab.com:8000"


// prod
export const PAYMENT_SECRET_KEY = "$2a$10$A5Kr7IU.tGkdS6hqzFNycuINs/b1ZseC7MS6fWeV68s76ANLQ9I/e"
export  const PAYMENT_GATEWAY_URL = "https://payment-gateway.lailaolab.com"
// export  const PAYMENT_GATEWAY_URL = "http://localhost:8000"

